<template>
  <div>
    <div class="heading-travel-policy">
      <span :class="rule.isActive ? 'tag is-success' : 'tag'">
        Standard rule
      </span>
      <div class="right-content">
        <div class="lefttext">
          <p class="paragrapgh">{{ title }}</p>
          <p>Trigger when a traveler chooses a flight with an airline for which there is no unused ticket stored on
            their profile.</p>
        </div>
        <div class="allbtns">
          <b-switch rounded left-label :value="rule.isActive" v-model="rule.isActive" @input="updateValue">
            {{ rule.isActive ? "Active" : "Inactive" }}
          </b-switch>
        </div>
      </div>
    </div>
    <StandardRuleActions v-if="rule.isActive" :ruleObj="rule" :title="title" @save="updateActions" />
  </div>
</template>

<script>
import StandardRuleActions from "../StandardRuleActions.vue";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        type: "air",
        isActive: false,
        name: "useUnusedTicketIfExists",
        message: "Trigger when a traveler chooses a flight with an airline for which there is no unused ticket stored on their profile.",
      }),
    },
  },
  components: {
    StandardRuleActions
  },
  data() {
    return {
      rule: null,
      title: "Unused Tickets"
    };
  },
  watch: {
    value: {
      handler() {
        const rule = JSON.stringify(this.rule);
        const value = JSON.stringify(this.value);

        if (rule !== value) {
          this.rule = this.value;
        }
      },
      deep: true,
    },
  },
  created() {
    this.rule = this.value;
    this.updateValue();
  },
  methods: {
    updateValue() {
      if (!this.rule.isActive) {
        // Clear the custom action parameters when deactivating
        this.clearActionParams();
      }

      this.emitRuleObj();
    },
    clearActionParams() {
      // Reset to default actions when rule is not active
      this.rule.useCustomActions = false;
      delete this.rule.visibility;
      delete this.rule.approvalLevel;
      delete this.rule.notifications;
    },
    updateActions(updatedRule) {
      // Merge the updated properties into rule
      this.rule = { ...this.rule, ...updatedRule };

      // If useCustomActions is false, delete the associated properties
      if (!updatedRule.useCustomActions) {
        this.clearActionParams()
      }

      this.emitRuleObj();
    },
    emitRuleObj() {
      this.$emit("update", this.rule);
    },
  },
};
</script>
